// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "price-1O91t";
var _3 = "meal-1Po0s";
var _4 = "title-2ZTXr";
export { _1 as "__esModule", _2 as "price", _3 as "meal", _4 as "title" }
export default { "__esModule": _1, "price": _2, "meal": _3, "title": _4 }
